export const areaStatementSorting = [
  {
    orderByKey: "MijnCNB_Status",
    orderByType: "desc",
  },
];

export const orderSorting = [
  {
    orderByKey: "VersionDate",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "desc",
  },
];

export const notificationSorting = [
  {
    orderByKey: "DateFrom",
    orderByType: "desc",
  },
];

export const adviceSorting = [
  {
    orderByKey: "Date",
    orderByType: "desc",
  },
];

export const invoiceSorting = [
  {
    orderByKey: "InvoiceDate",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "desc",
  },
];

export const accountStatementsSorting = [
  {
    orderByKey: "DocumentDate",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "desc",
  },
];

export const statementsSorting = [
  {
    orderByKey: "PaymentDate",
    orderByType: "asc",
  },
  {
    orderByKey: "Version",
    orderByType: "asc",
  },
];

export const statementsInvoiceSorting = [
  {
    orderByKey: "Invoice/InvoiceDate",
    orderByType: "asc",
  },
  {
    orderByKey: "Invoice/Number",
    orderByType: "asc",
  },
];

export const myDeliveriesSorting = [
  {
    orderByKey: "Order/DeliveryPeriodEnd",
    orderByType: "desc",
  },
  {
    orderByKey: "Order/Number",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "asc",
  },
];

export const deliveriesSorting = [
  {
    orderByKey: "Date",
    orderByType: "desc",
  },
  {
    orderByKey: "DeliveryId",
    orderByType: "desc",
  },
];

export const receiptReturnSorting = [
  {
    orderByKey: "Date",
    orderByType: "desc",
  },
  {
    orderByKey: "ReceiptId",
    orderByType: "desc",
  },
];

export const qualityReportSorting = [
  {
    orderByKey: "Date",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "desc",
  },
];

export const inspectionReportSorting = [
  {
    orderByKey: "Date",
    orderByType: "desc",
  },
  {
    orderByKey: "Number",
    orderByType: "desc",
  },
];
